module.exports = __webpack_public_path__ + "media/photos/term-bg-4-2d526a35.jpg";